<div class="app-loader">
  <div class="loader-content">
    <div class="loader-logo"></div>
    <div class="loader-bar"><span></span></div>
    <p class="loader-text">The cloud operations platform</p>
  </div>
</div>
